// extracted by mini-css-extract-plugin
export var accordionBg = "Faq-module--accordionBg--dFSUt";
export var accordionBtn = "Faq-module--accordionBtn--P3tEY";
export var accordionItem = "Faq-module--accordionItem--iaiA2";
export var accordionTitle = "Faq-module--accordionTitle--etwBp";
export var accordionTop = "Faq-module--accordionTop--Mn5Xj";
export var collapsed = "Faq-module--collapsed--Nl9LI";
export var darkHr = "Faq-module--darkHr--z5i+Y";
export var darkHr2 = "Faq-module--darkHr2--2pumB";
export var desc = "Faq-module--desc--eGoWp";
export var faq = "Faq-module--faq--SbDPT";
export var faq__para = "Faq-module--faq__para--kOvmK";
export var heading = "Faq-module--heading--YhiUN";
export var healList = "Faq-module--healList--y+H5y";